import React from 'react';
import PropTypes from 'prop-types';

import assetUrl from '../../../utils/assetUrl';

const iconDir = assetUrl('images');

const CvvCodeInputField = ({
    isHelper, onClickHelp, field, ...restProps
}) => (
    <div className="cvvcode-input-wrapper">
        <input type="text" {...restProps} {...field} />

        {/* Button shows/hides a tooltip */}
        {isHelper && (
            <button
                className="cvvcode-helper-button"
                type="button"
                onClick={onClickHelp}
                style={{backgroundImage: `url(${iconDir}/help.svg)`}}
            />
        )}
    </div>
);

CvvCodeInputField.propTypes = {
    isHelper: PropTypes.bool,
    onClickHelp: PropTypes.func
};

CvvCodeInputField.defaultProps = {
    isHelper: false,
    onClickHelp: () => {}
};

export default CvvCodeInputField;
